<script setup lang="ts">
import type { Album, Channel } from '~/types'

import axios from 'axios'
import { ref, watch, reactive } from 'vue'
import { useI18n } from 'vue-i18n'

import AlbumModal from '~/components/channels/AlbumModal.vue'
import Link from '~/ui/Link.vue'
import Spacer from '~/ui/Spacer.vue'
import { dialog } from '~/routing'

const { t } = useI18n()

const props = defineProps<{
  channel?: Channel | null
}>()

const selectedAlbumId = defineModel<Album['id'] | null>()

const albums = reactive<Album[]>([])

const isLoading = ref(false)
const fetchData = async () => {
  albums.length = 0
  if (!props.channel?.artist) return

  isLoading.value = true
  const response = await axios.get('albums/', {
    params: {
      artist: props.channel?.artist.id,
      include_channels: 'true'
    }
  })

  albums.push(...response.data.results)
  isLoading.value = false
}

watch(() => props.channel, fetchData, { immediate: true })
</script>

<template>
  <label for="album-dropdown">
    <span v-if="channel && channel.artist && channel.artist.content_category === 'podcast'">
      {{ t('components.channels.AlbumSelect.label.series') }}
    </span>
    <span v-else>
      {{ t('components.channels.AlbumSelect.label.album') }}
    </span>
    <select
      id="album-dropdown"
      v-model="selectedAlbumId"
      class="ui search normal dropdown"
    >
      <option value="">
        {{ t('components.channels.AlbumSelect.option.none') }}
      </option>
      <option
        v-for="album in albums"
        :key="album.id"
        :value="album.id"
      >
        {{ album.title }}
        {{ `(${t('components.channels.AlbumSelect.meta.tracks', album.tracks_count)})` }}
      </option>
    </select>
  </label>
  <!-- TODO: Use Select component -->
  <Spacer :size="4" />
  <Link
    class="color-primary-solid"
    v-bind="dialog.to('album')"
    ui-block-size="48"
    ui-no-underline
  >
    <Icon icon="bi:plus" />
    {{ t('components.channels.AlbumSelect.add') }}
  </Link>
  <AlbumModal
    :channel="props.channel ?? { artist: {} } as Channel"
    v-bind="dialog.model('album')"
    @created="(title) => fetchData().then(() => {
      console.log(title)
        selectedAlbumId = albums.find(a => a.title === title)?.id ?? selectedAlbumId
      })"
  />
</template>
